<template>
<div class="container-fluid">
	
	<toolbar>
		<a href="#" v-if="activeComponent" v-on:click.prevent="backToSettings">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>Settings</h2>
		</a>
		<h2 v-else><i class="fa fa-cog"></i> Settings</h2>

		<div class="controls">
			<search-bar v-if="!activeComponent" placeholder="Filter settings..." v-on:termsChange="setSearchTerms"></search-bar>
		</div>
	</toolbar>

	<widget v-if="activeComponent && wrapInWidget" :title="wrapInWidget ? false : componentTitle">
		<component :is="activeComponent" :is-settings-component="true"></component>
	</widget>
	<component v-else-if="activeComponent" :is="activeComponent" :is-settings-component="true"></component>

	<widget v-else>
		<div v-for="(section,index) in menuItems" 
			v-if="showSection(section)" 
			class="ml-2 mr-2 mb-4">

			<h3 v-if="'heading' in section && filterMenuItems(section.items).length > 0">{{ section.heading }}</h3>

			<div class="row row-eq-height no-gutters">

				<div v-for="item in filterMenuItems(section.items)"
					v-if="!('modulePermRequired' in item) || hasPerm(item.modulePermRequired)"
					class="col-xl-3 col-lg-4 col-md-6">

					<a href="#" v-on:click.prevent="setSelectedItem(item)" class="setting-button" :class="{'disabled': filterNavForPerms([item]).length == 0}">
						<div class="d-flex">
							<div>
								<div class="icon-box"><i class="fa fa-fw" :class="item.icon"></i></div>
							</div>
							<div>		
								<h5>{{item.text}}</h5>
								<p>{{ item.description }}</p>
								<p v-if="filterNavForPerms([item]).length == 0"><small><i class="fa fa-lock"></i> You don't have permission to access this setting</small></p>
							</div>
						</div>
					</a>
				</div>
			</div>
			<hr v-if="index < menuItems.length - 1">
		</div>
	</widget>

</div>
</template>
<script type="text/javascript">
import Widget from "../components/Widget"
import Toolbar from "../layout_fragments/Toolbar"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"
import SearchBar from "@/components/SearchBar"

import Subscription from "@/pages/Subscription"
import SettingsCompanyDetails from "@/pages/settings/SettingsCompanyDetails"
import ChargeOutGroups from "@/pages/employees/ChargeOutGroups"

import ExpenseCodes from "@/pages/settings/ExpenseCodes"

import TaxSettings from "@/components/super_components/TaxSettings"
import CompanyAddresses from "@/components/super_components/CompanyAddresses"
import InvoiceSettings from "@/components/super_components/InvoiceSettings"
import EmployeeClassifications from "@/pages/employees/EmployeeClassifications"
import PayAdjustments from "@/pages/employees/PayAdjustments"
import PaymentAcceptanceSettings from "@/components/super_components/PaymentAcceptanceSettings"
import Integrations from "@/pages/apps/Integrations"
import PermissionTemplates from "@/pages/settings/PermissionTemplates"
import TimeLogSettings from "@/pages/time_logs/TimeLogSettings"
import PersonnelRolesWidget from "@/components/super_components/PersonnelRolesWidget"

import ChecklistsManagerWidget from "@/components/super_components/ChecklistsManagerWidget"

import ScheduleSettings from "@/components/super_components/ScheduleSettings"


import CategoryManagerWidget from "@/components/super_components/CategoryManagerWidget"
import RevenueCodeManagerWidget from "@/components/super_components/RevenueCodeManagerWidget"
import FileTagManagerWidget from "@/components/super_components/FileTagManagerWidget"
import ProjectDefaultSettings from "@/components/super_components/ProjectDefaultSettings"
import JobSafetyTasksManagerWidget from "@/components/super_components/JobSafetyTasksManagerWidget"
import EquipmentTypes from "@/pages/equipment/EquipmentTypes"
import ServiceListSettingsWidget from "@/components/super_components/ServiceListSettingsWidget"

import TimeoffSettings from "@/pages/employees/TimeoffSettings"
import AccountSettings from "@/pages/employees/employee_tabs/AccountSettings"
import SettingsUnions from "@/pages/settings/SettingsUnions"

import MaterialsSettings from "@/pages/materials/MaterialsSettings" 
import JobNumberingSettings from "@/components/super_components/JobNumberingSettings"
import CustomerAssetCategoriesManagerWidget from "@/components/super_components/CustomerAssetCategoriesManagerWidget"
import QrCodeManagerWidget from "@/components/super_components/QrCodeManagerWidget"
import CustomerAssetTemplatesManagerWidget from "@/components/super_components/CustomerAssetTemplatesManagerWidget"

import PricingDefaultsWidget from "@/components/super_components/PricingDefaultsWidget"

export default {
	name: "MainSettings",
	components: {
		Widget,
		SearchBar,
		Toolbar,
		CollapsiblePanel,
		PanelMenu,
		Subscription,
		SettingsCompanyDetails,
		TaxSettings,
		CompanyAddresses,
		InvoiceSettings,
		ChargeOutGroups,
		EmployeeClassifications,
		PayAdjustments,
		PaymentAcceptanceSettings,
		Integrations,
		PermissionTemplates,
		TimeLogSettings,
		PersonnelRolesWidget,
		CategoryManagerWidget,
		RevenueCodeManagerWidget,
		FileTagManagerWidget,
		ProjectDefaultSettings,
		JobSafetyTasksManagerWidget,
		AccountSettings,
		SettingsUnions,
		MaterialsSettings,
		TimeoffSettings,
		JobNumberingSettings,
		CustomerAssetCategoriesManagerWidget,
		QrCodeManagerWidget,
		CustomerAssetTemplatesManagerWidget,
		ExpenseCodes,
		PricingDefaultsWidget,
		EquipmentTypes,
		ScheduleSettings,
		ServiceListSettingsWidget,
		ChecklistsManagerWidget,
	},
	data() {
		return {
			activeComponent: null,
			wrapInWidget: false,
			componentTitle: "",
			selectedItem: null,
			menuItems: [
				{
					items: [
						{
							text: "Tradetraks Subscription", 
							icon: "fa-credit-card",
							modulePermRequired: ["Settings"],
							description: "Manage your subscription to Tradetraks",
							url: window.apiRoot + "outbound/subscription/" + this.$store.company.slug + "/" + this.$store.sessionToken
						},
						{
							text: "Integrations", 
							icon: "fa-puzzle-piece",
							component: "Integrations",
							modulePermRequired:["Settings"],
							description: "Integrate with 3rd party systems like Quickbooks, and connect to your own SMTP mail server",
						},
						{
							text: "Personal Account Settings", 
							icon: "fa-cog",
							component: "AccountSettings",
							description: "Change your password, and manage personal account and privacy preferences",
						}
					]	
				},
				{
					heading: "Company Management",
					sectionPermissions: ["Settings"],
					items: [
						{
							text: "Company Details",
							icon: "fa-building",
							component: "SettingsCompanyDetails",
							modulePermRequired: ["Settings"],
							description: "Manage company details, head office & billing addresses, and company roles"
						},
						{
							text: "Company Addresses",
							icon: "fa-building",
							component: "CompanyAddresses",
							modulePermRequired: ["Settings"],
							description: "Manage additional company addresses"
						},
						{
							text: "Outbound Document Settings", 
							icon: "fa-share-square",
							component: "InvoiceSettings",
							modulePermRequired:["Settings"],
							description: "Manage visual and default settings for outbound PDF documents (quotes, invoices, purchase orders, and work order summaries)",
						},
						{
							text: "Schedule Settings", 
							icon: "fa-calendar-alt",
							component: "ScheduleSettings",
							modulePermRequired:["Settings"],
							description: "Manage schedule settings and defaults",
						}
					]	
				},
				{
					heading: "Employee Management",
					sectionPermissions: ["Settings","Users","TimeLogs"],
					items: [
						{
							text: "Payroll Settings", 
							icon: "fa-clock",
							component: "TimeLogSettings",
							modulePermRequired:["Settings","TimeLogs"],
							description: "Set up the pay period interval, the start dates of pay periods, and which levels of overtime are available to claim.",
							wrapInWidget: true
						},
						{
							text: "Time-Off Settings", 
							icon: "fa-umbrella-beach",
							component: "TimeoffSettings",
							modulePermRequired:["Settings"],
							description: "Choose when employee vacation days reset"
						},
						{
							text: "Employee Classifications", 
							icon: "fa-users",
							component: "EmployeeClassifications",
							modulePermRequired:["Settings","Users"],
							description: "Set up classifications for employees",
							wrapInWidget: true
						},
						{
							text: "Compensation Groups & Unions", 
							icon: "fa-users",
							component: "SettingsUnions",
							modulePermRequired:["Settings","Users"],
							description: "Group employee classifications into groups with the same billing rate",
							wrapInWidget: true
						},
						{
							text: "Pay Adjustments", 
							icon: "fa-ticket-alt",
							component: "PayAdjustments",
							modulePermRequired:["Settings","Users"],
							description: "Create special-case adjustments to pay (ex. Night premium, hazard pay, etc).",
							wrapInWidget: true
						},
						{
							text: "Permissions Templates", 
							icon: "fa-lock",
							component: "PermissionTemplates",
							modulePermRequired:["Settings","Users"],
							description: "Set up templates that can be applied to employees to determine what access they have to Tradetraks modules",
							wrapInWidget: true
						}
					]	
				},
				{
					heading: "Billing & Accounting",
					sectionPermissions: ["Settings","Users"],
					items: [
						{
							text: "Sales Tax Setup", 
							icon: "fa-percent",
							component: "TaxSettings",
							modulePermRequired:["Settings"],
							description: "Manage sales tax",
						},
						{
							text: "Payment Gateways", 
							icon: "fa-credit-card",
							component: "PaymentAcceptanceSettings",
							modulePermRequired:["Settings"],
							description: "Set up to receive invoice payments through supported payment gateways, like Stripe & Paypal",
						},
						{
							text: "Charge Out Groups", 
							icon: "fa-tags",
							component: "ChargeOutGroups",
							modulePermRequired:["Settings","Users"],
							description: "Group employee classifications into groups with the same billing rate",
							wrapInWidget: true
						},
						{
							text: "Revenue Codes", 
							icon: "fa-calculator",
							component: "RevenueCodeManagerWidget",
							description: "Set up revenue codes that projects & services can be assigned to",
							modulePermRequired:["Settings"],
						},
						{
							text: "Expense Codes", 
							icon: "fa-hashtag",
							component: "ExpenseCodes",
							description: "Set up expense codes in order to categorize expenses",
							modulePermRequired:["Settings"],
						},
						{
							text: "Pricing Defaults", 
							icon: "fa-dollar-sign",
							component: "PricingDefaultsWidget",
							description: "Set up global defaults for Price Adjustments and Markups",
							modulePermRequired:["Settings"],
						}
					]	
				},
				{
					heading: "Project & Service Setup",
					hasAllPerms: ["Settings","Projects","Services"],
					items: [
						{
							text: "Personnel Roles", 
							icon: "fa-user",
							component: "PersonnelRolesWidget",
							description: "Manage personnel role types that you use on Projects/Services (ex. Project Manager, Foreman, Labourer, etc)",
							modulePermRequired:["Settings"],
						},
						{
							text: "Categories", 
							icon: "fa-tag",
							component: "CategoryManagerWidget",
							description: "Project/service categories for better reporting",
							modulePermRequired:["Settings"],
						},
						{
							text: "File Tags", 
							icon: "fa-tags",
							component: "FileTagManagerWidget",
							description: "Create the tag list for better organizing files uploaded to the library, projects, services, and service contracts",
							modulePermRequired:["Settings"],
						},
						{
							text: "Job Safety Tasks", 
							icon: "fa-list",
							component: "JobSafetyTasksManagerWidget",
							description: "Manage the list of worker tasks with associated hazards and controls to streamline completion of safety forms",
							modulePermRequired:["Safety"],
						},
						{
							text: "Job Defaults", 
							icon: "fa-file",
							component: "ProjectDefaultSettings",
							description: "Set default values for common Project/Service fields in order to streamline creating new Projects or Services",
							modulePermRequired:["Settings","Jobs"],
						},
						{
							text: "Project/Service Numbering", 
							icon: "fa-hashtag",
							component: "JobNumberingSettings",
							description: "Control the editability of Project & Service numbers",
							modulePermRequired:["Settings"],
						},
						{
							text: "Service List Settings", 
							icon: "fa-wrench",
							component: "ServiceListSettingsWidget",
							description: "Select the default columns showing on the Services list",
							modulePermRequired:["Settings"],
						},
					]	
				},
				{
					heading: "Customer Asset Management",
					hasAllPerms: ["Settings"],
					items: [
						{
							text: "Asset Categories",
							icon: "fa-tags",
							component: "CustomerAssetCategoriesManagerWidget",
							description: "Set up and manage categories for customer assets",
							modulePermRequired:["Customer Assets"]
						},
						{
							text: "Asset Templates",
							icon: "fa-tags",
							component: "CustomerAssetTemplatesManagerWidget",
							description: "Set up and manage templates for customer assets",
							modulePermRequired:["Customer Assets"]
						}
					]
				},
				{
					heading: "Database Settings",
					hasAllPerms: ["Settings"],
					items: [
						{
							text: "Materials Settings", 
							icon: "fa-tags",
							component: "MaterialsSettings",
							description: "Manage material assemblies tags",
							modulePermRequired:["Settings"]
						},
						{
							text: "Equipment Database Settings", 
							icon: "fa-truck",
							component: "EquipmentTypes",
							description: "Set up and manage equipment types, categories, and maintenance events",
							modulePermRequired:["Equipment"]
						},
						{
							text: "QR Codes",
							icon: "fa-qrcode",
							component: "QrCodeManagerWidget",
							description: "Create and manage new QR codes for your company",
							modulePermRequired:["Settings"]
						},
						{
							text: "Checklists",
							icon: "fa-check-square",
							component: "ChecklistsManagerWidget",
							description: "Create and update checklists",
							modulePermRequired:["Settings"]
						}
					]	
				},
				
				/*

				{
					text: "Billing", 
					icon: "fa-fw fa-credit-card-alt",
					anyModulePerms:['Settings','Materials'],
					description: "Manage invoice settings, charge out groups, and payment gateways"
				},
				{
					text: "Module Settings", 
					icon: "fa-fw fa-cog",
					anyModulePerms:['Settings','Materials','Equipment','Certificates'],
					description: "Specific settings for each module"
				},
				{
					text: "Apps & Integrations", 
					icon: "fa-fw fa-th-large",
					anyModulePerms:["Settings"],
					description: "Manage addon apps & third party platform integrations"
				},
				{
					text: "Personal Account Settings", 
					icon: "fa-fw fa-user-circle",
					description: "Change password, manage notification/email settings and account preferences"
				}*/
			],
			searchTerms: ""
		}
	},
	methods: {
		filterMenuItems(items) {
			let vm = this

			if (this.searchTerms) {
				return items.filter(item => {
					if (item.description.toLowerCase().search(vm.searchTerms.toLowerCase()) >= 0)
						return true
					else if (item.text.toLowerCase().search(vm.searchTerms.toLowerCase()) >= 0)
						return true

					else return false
				})
			}
			else 
				return items
		},
		setSearchTerms(terms) {
			this.searchTerms = terms
		},
		setSelectedItem(item) {
			this.selectedItem = item

			if ("component" in item) {
				this.activeComponent = item.component
				this.wrapInWidget = "wrapInWidget" in item ? true : false
				this.componentTitle = item.text

				window.history.pushState({},"","/settings/"+item.text.slugify())
			}
			else if ("url" in item)
				window.location = window.apiRoot + "outbound/subscription/" + this.$store.company.slug + "/" + this.$store.sessionToken
		},
		backToSettings() {
			this.activeComponent = null
			this.componentTitle = ""
			window.history.pushState({},"","/settings")
		},
		hasPerm(modules) {
			let vm  = this

			if (this.getUserRoleType() == "Admin")
				return true
			else {
				let hasPerm = true
				modules.forEach(mod => {
					if (!vm.hasModulePermWrite(mod))
						hasPerm = false
				})

				return hasPerm
			}
		},
		hasAny(modules) {
			let vm = this

			if (this.getUserRoleType() == "Admin")
				return true
			else {
				let hasPerm = false
				modules.forEach(mod => {
					if (vm.hasModulePermWrite(mod))
						hasPerm = true
				})

				return hasPerm
			}
		},
		showSection(section) {
			if ("hasAllPerms" in section) 
				return this.hasPerm(section.hasAllPerms)
			else if ("sectionPermissions" in section)
				return this.hasAny(section.sectionPermissions)

			return true
		}
	},
	created() {
		let vm = this
		if ("tab" in this.$route.params) {
			//set activeComponent
			this.menuItems.find(section => {
				let match = section.items.find(item => item.text.slugify() == vm.$route.params.tab)

				if (match) {
					this.selectedItem = match

					this.activeComponent = match.component
					this.wrapInWidget = "wrapInWidget" in match ? match.wrapInWidget : false
					this.componentTitle = match.text
				}
			})
		}
	}
}
</script>

<style type="text/css" scoped>
	.setting-button {
		color: inherit;
		padding: 10px;
		display: block;
		margin-bottom: 10px;
		height: 100%;
	}

	.setting-button.disabled {
		color: #606060;
		opacity: 0.8;
	}

	.setting-button:hover {
		text-decoration: none;
		cursor: pointer;
		background-color: #fbfbfb;
	}

	.setting-button.disabled:hover {
		cursor: not-allowed;
		background: transparent;
	}

	.setting-button .icon-box {
		background-color: #EAE9E7;
		padding: 5px;
		font-size: 20px;
		margin-right: 10px;
		color: #606060;
		border-radius: 2px;
	}

	.setting-button h5 {
		font-size: 14pt;
		margin-bottom: 0;
		color: var(--brand-primary-color);
	}

	.setting-button.disabled h5 {
		color: #606060;
	}

	.setting-button:hover h5 {
		color: #084e8a;
	}

	.setting-button.disabled:hover h5 {
		color: inherit;
	}

	.setting-button p {
		margin-bottom: 0;
	}
</style>